import { render } from "./CreatePlanDetailTaskForm.vue?vue&type=template&id=31260152&scoped=true"
import script from "./CreatePlanDetailTaskForm.vue?vue&type=script&lang=js"
export * from "./CreatePlanDetailTaskForm.vue?vue&type=script&lang=js"

import "./CreatePlanDetailTaskForm.vue?vue&type=style&index=0&id=31260152&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31260152"]])

export default __exports__